import AuthService from './ports/AuthService';
import CustomsBrokerService from './ports/CustomsBrokerService';
import DocumentService from './ports/DocumentService';
import { FileSaverService } from './ports/FileSaver';
import LinehaulCompanyService from './ports/LinehaulCompanyService';
import ManifestService from './ports/ManifestService';
import LoadingRestrictionService from './ports/LoadingRestrictionService';
import LocationService from './ports/LocationService';
import PersistenceService from './ports/PersistenceService';
import ShipmentGroupService from './ports/ShipmentGroupService';
import TruckService from './ports/TruckService';
import { createReduxLocationProvider } from './adapters/redux-providers';
import CentralizedAuthService from './adapters/CentralizedAuthService';
import SOPRestService from './adapters/SOPRestService';
import LocalStorageService from './adapters/LocalStorageService';
import { saveAs } from 'file-saver';
import Provider from './ports/Provider';
import { Location } from './models/location';
import LoggingService from './ports/LoggingService';
import FeatureFlagsService from './ports/FeatureFlagsService';
import { StoreState } from './store/state';
import { ShipmentsService } from './ports/ShipmentsService';
import { WorkflowsService } from './ports/WorkflowService';

export interface AppServices {
  authService: AuthService;
  customsBrokerService: CustomsBrokerService;
  documentsService: DocumentService;
  fileSaverService: FileSaverService;
  linehaulCompanyService: LinehaulCompanyService;
  manifestService: ManifestService;
  loadingRestrictionService: LoadingRestrictionService;
  locationService: LocationService;
  persistenceService: PersistenceService;
  shipmentGroupService: ShipmentGroupService;
  truckService: TruckService;
  loggingService: LoggingService;
  featureFlagsService: FeatureFlagsService;
  providers: {
    locationProvider: Provider<Location>;
  };
  shipmentsService: ShipmentsService;
  workflowsService: WorkflowsService;
}

export function createAppServices(store: { getState: () => StoreState }): AppServices {
  const locationProvider = createReduxLocationProvider(store);
  const authService = new CentralizedAuthService();
  const backendService = new SOPRestService(authService, locationProvider);
  const persistenceService = new LocalStorageService();

  return {
    authService,
    persistenceService,
    workflowsService: backendService,
    customsBrokerService: backendService,
    documentsService: backendService,
    fileSaverService: saveAs,
    linehaulCompanyService: backendService,
    manifestService: backendService,
    loadingRestrictionService: backendService,
    locationService: backendService,
    shipmentGroupService: backendService,
    truckService: backendService,
    loggingService: backendService,
    featureFlagsService: backendService,
    providers: {
      locationProvider,
    },
    shipmentsService: backendService,
  };
}
